import { Component, Input } from "@angular/core";

import {
    registerSvgs,
    svgArrowRounded,
    SvgIconComponent,
    svgMinus,
    svgPlus,
} from "@hermes/aphrodite/svg";

import { iconAnimation } from "../../animations/icon.animation";

export const ARROW = "arrow";
export const PLUS_MINUS = "plus-minus";
export type ExpansionPanelIconStyle = typeof ARROW | typeof PLUS_MINUS;

@Component({
    selector: "h-expansion-panel-icon",
    templateUrl: "./expansion-panel-icon.component.html",
    styleUrls: ["./expansion-panel-icon.component.scss"],
    animations: [iconAnimation],
    imports: [SvgIconComponent],
    standalone: true,
})
export class ExpansionPanelIconComponent {
    @Input()
    public expansionPanelStyle: ExpansionPanelIconStyle = ARROW;
    @Input()
    public showIcon? = true;
    @Input()
    public collapsed = true;
    @Input()
    public shouldPlusMinusSvgHaveSmallDimensions = false;
    @Input()
    public shouldPlusMinusSvgHavePrimaryDarkStroke = false;
    @Input()
    public shouldPlusMinusSvgHaveSmallStrokeWidth = false;

    constructor() {
        registerSvgs([svgPlus, svgMinus, svgArrowRounded]);
    }
}
